function Jersey({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1425)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M28.6936 25.742L18.9515 15.9998H18.9514L28.6936 6.25753C28.2735 5.71153 27.8138 5.18621 27.3138 4.68603C26.8136 4.1859 26.2883 3.72621 25.7423 3.30615L16.0001 13.0483L16 13.0484L6.25783 3.30615C5.7119 3.72628 5.18652 4.18584 4.68633 4.68603C4.18615 5.18621 3.72652 5.71153 3.30646 6.25753L13.0486 15.9996L13.0487 15.9997L3.3064 25.742C3.72658 26.288 4.18621 26.8133 4.68627 27.3135C5.18646 27.8136 5.71171 28.2733 6.25777 28.6934L16 18.9512L16.0001 18.9511L25.7423 28.6933C26.2882 28.2732 26.8136 27.8136 27.3138 27.3135C27.8139 26.8133 28.2735 26.288 28.6936 25.742Z" fill="#D80027"/>
  <path d="M13.2174 4.86936L16 5.56499L18.7827 4.86936V2.50418L17.6696 3.06067L16 1.39111L14.3305 3.06067L13.2174 2.50418V4.86936Z" fill="#FFDA44"/>
  <path d="M13.2174 4.86963V6.60888C13.2174 8.73888 16 9.3915 16 9.3915C16 9.3915 18.7827 8.73882 18.7827 6.60888V4.86963H13.2174Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Jersey;
